import { callPostApi } from '@/components/api-common';
import { OrgPaymentSettings } from './user';

export type PaymentSettings = {
  support_ach?: boolean;
  support_credit_card?: boolean;
};

export type ProjectPaymentSettings = {
  project_payment_settings: {
    support_ach: boolean | null; // 是否支持ACH支付
    support_credit_card: boolean | null; // 是否支持信用卡支付
  } | null; // 如果project上没有配置过payment_settings返回null
  org_payment_settings: OrgPaymentSettings;
};

export async function getProjectPaymentSettings(project_id: string) {
  return callPostApi<ProjectPaymentSettings>(
    'user/service/my/project/get_payment_settings/',
    {
      project_id,
    }
  );
}

export async function updateProjectPaymentSettings(
  project_id: string,
  settings: {
    support_ach?: boolean;
    support_credit_card?: boolean;
    charge_platform_fee?: boolean;
  }
) {
  await callPostApi('user/service/my/project/update_payment_settings/', {
    project_id,
    ...settings,
  });
}

export async function getPaymentSettings() {
  return callPostApi<{
    enabled: boolean;
    support_credit_card: boolean;
    support_ach: boolean;
    provider: 'pay_abli' | 'pay_engine';
    charge_platform_fee: boolean;
    platform_fee_percent: string;
  }>('/user/service/payments/payment_settings/');
}
